let isDevLocal = process.env.NODE_ENV !== 'production';

const useProductionAPI = true;
const useStubs = false;
const stripePublisableKey = 'pk_live_Upe9mij3QzMr0G5gchPO11LT';
const stripePublisableKeyTest = 'pk_test_p1bZoMmxvbvYw0wGF1IvmruX';

let baseUrl = useStubs
  ? 'http://localhost:5000'
  : useProductionAPI
  ? 'https://api.traveladviceapi.com'
  : 'https://staging.traveladviceapi.com';

let stripeKey = useProductionAPI ? stripePublisableKey : stripePublisableKeyTest;

let baseUrlVersioned = `${baseUrl}/v1`;

export default {isDevLocal, baseUrl, baseUrlVersioned, useStubs, stripeKey};
